/**
 * RETOBLOCK LIST INITIALIZER MODAL
 * Hộp thoại thiết lập giá trị ban đầu cho các danh sách dữ liệu trong kịch bản Scratch.
 * Cho phép xem, chỉnh sửa, thêm, xóa các phần tử ban đầu cho từng danh sách đã tạo.
 */

export class ListInitModal {
  constructor(options = {}) {
    this.container = options.container || document.body;
    this.getWorkspace = options.getWorkspace || null;
    this.onSave = options.onSave || null;
    this.onOpenCreateList = options.onOpenCreateList || null;

    this.activeListId = null;
    this.listData = {}; // { [listName]: Array<string|number> }

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="modal-overlay" id="list-init-modal-overlay">
        <div class="modal-card list-init-modal-card">
          <div class="modal-header list-init-modal-header">
            <div class="modal-title">
              <span class="list-init-modal-badge">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="8" y1="6" x2="21" y2="6"/>
                  <line x1="8" y1="12" x2="21" y2="12"/>
                  <line x1="8" y1="18" x2="21" y2="18"/>
                  <line x1="3" y1="6" x2="3.01" y2="6"/>
                  <line x1="3" y1="12" x2="3.01" y2="12"/>
                  <line x1="3" y1="18" x2="3.01" y2="18"/>
                </svg>
              </span>
              <span>Thiết lập giá trị ban đầu cho Danh sách</span>
            </div>
            <button class="btn-close-modal" id="btn-close-list-init-modal" title="Đóng">&times;</button>
          </div>

          <div class="modal-body list-init-modal-body" id="list-init-modal-body">
            <!-- Dynamic Content Rendered Here -->
          </div>

          <div class="modal-footer list-init-modal-footer">
            <button type="button" class="btn-secondary-modal" id="btn-cancel-list-init">HỦY</button>
            <button type="button" class="btn-confirm-list-init" id="btn-save-list-init">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
              <span>LƯU THIẾT LẬP</span>
            </button>
          </div>
        </div>
      </div>
    `;

    this.bindEvents();
  }

  bindEvents() {
    this.overlay = document.getElementById('list-init-modal-overlay');
    this.bodyEl = document.getElementById('list-init-modal-body');
    const closeBtn = document.getElementById('btn-close-list-init-modal');
    const cancelBtn = document.getElementById('btn-cancel-list-init');
    const saveBtn = document.getElementById('btn-save-list-init');

    closeBtn.addEventListener('click', () => this.hide());
    cancelBtn.addEventListener('click', () => this.hide());

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.hide();
      }
    });

    saveBtn.addEventListener('click', () => this.handleSave());

    window.addEventListener('keydown', (e) => {
      if (this.overlay && this.overlay.classList.contains('active')) {
        if (e.key === 'Escape') {
          this.hide();
        }
      }
    });
  }

  show() {
    const ws = this.getWorkspace ? this.getWorkspace() : null;
    let listVars = [];
    if (ws && ws.getVariableMap) {
      listVars = ws.getVariableMap().getVariablesOfType('list') || [];
    }

    // Load initial values state
    const savedInits = (ws && ws.listInitialValues) ? JSON.parse(JSON.stringify(ws.listInitialValues)) : {};
    this.listData = {};

    listVars.forEach(v => {
      const name = typeof v === 'string' ? v : (v.name || (v.getName ? v.getName() : ''));
      if (name) {
        this.listData[name] = savedInits[name] ? [...savedInits[name]] : [];
      }
    });

    this.renderBody(listVars);
    this.overlay.classList.add('active');
  }

  renderBody(listVars) {
    if (!listVars || listVars.length === 0) {
      this.bodyEl.innerHTML = `
        <div class="list-init-empty-state">
          <div class="empty-icon-wrapper">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="1.5">
              <line x1="8" y1="6" x2="21" y2="6"/>
              <line x1="8" y1="12" x2="21" y2="12"/>
              <line x1="8" y1="18" x2="21" y2="18"/>
              <line x1="3" y1="6" x2="3.01" y2="6"/>
              <line x1="3" y1="12" x2="3.01" y2="12"/>
              <line x1="3" y1="18" x2="3.01" y2="18"/>
            </svg>
          </div>
          <h3>Chưa có danh sách nào được tạo</h3>
          <p>Hãy tạo ít nhất một danh sách trong danh mục DANH SÁCH trước khi thiết lập giá trị ban đầu.</p>
          <button type="button" class="btn-create-first-list" id="btn-create-first-list">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span>Tạo danh sách mới</span>
          </button>
        </div>
      `;

      const createBtn = document.getElementById('btn-create-first-list');
      if (createBtn) {
        createBtn.addEventListener('click', () => {
          this.hide();
          if (this.onOpenCreateList) this.onOpenCreateList();
        });
      }
      return;
    }

    const listNames = Object.keys(this.listData);
    if (!this.activeListId || !this.listData[this.activeListId]) {
      this.activeListId = listNames[0];
    }

    this.bodyEl.innerHTML = `
      <div class="list-init-layout">
        <!-- Sidebar tabs for created lists -->
        <div class="list-tabs-sidebar">
          <div class="sidebar-title">Danh Sách Đã Tạo (${listNames.length})</div>
          <div class="tabs-list" id="tabs-list-container">
            ${listNames.map(name => `
              <div class="list-tab-item ${name === this.activeListId ? 'active' : ''}" data-list-name="${name}">
                <span class="tab-badge-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                </span>
                <span class="tab-name">${name}</span>
                <span class="tab-count-pill" id="pill-${name}">${this.listData[name].length}</span>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Main Items Editor Area -->
        <div class="list-editor-panel" id="list-editor-panel">
          ${this.renderActiveListEditor()}
        </div>
      </div>
    `;

    this.bindEditorEvents();
  }

  renderActiveListEditor() {
    const name = this.activeListId;
    const items = this.listData[name] || [];

    return `
      <div class="editor-header-bar">
        <div class="editor-title">
          <span>Danh sách:</span>
          <strong>${name}</strong>
          <span class="item-count-label">(${items.length} phần tử)</span>
        </div>
        <div class="editor-actions">
          <button type="button" class="btn-quick-edit" id="btn-quick-bulk-edit" title="Nhập nhanh chuỗi phân cách bởi dấu phẩy">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            <span>Nhập nhanh CSV</span>
          </button>
          <button type="button" class="btn-clear-all" id="btn-clear-list-items" title="Xóa tất cả phần tử trong danh sách này">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            <span>Xóa sạch</span>
          </button>
        </div>
      </div>

      <!-- Quick Bulk Edit Box (collapsible) -->
      <div class="bulk-edit-box" id="bulk-edit-box" style="display: none;">
        <label>Nhập danh sách các giá trị ban đầu (phân cách bằng dấu phẩy):</label>
        <textarea id="bulk-csv-input" placeholder="Ví dụ: 10, 20, 30, RED, GREEN"></textarea>
        <div class="bulk-actions">
          <button type="button" class="btn-apply-bulk" id="btn-apply-bulk">Áp dụng</button>
          <button type="button" class="btn-cancel-bulk" id="btn-cancel-bulk">Hủy</button>
        </div>
      </div>

      <!-- Items List Table -->
      <div class="items-scroll-area">
        ${items.length === 0 ? `
          <div class="no-items-hint">
            <span>Danh sách "${name}" đang rỗng. Bấm "+ Thêm phần tử" để bắt đầu khởi tạo giá trị.</span>
          </div>
        ` : `
          <div class="items-grid" id="items-grid">
            ${items.map((val, idx) => `
              <div class="item-row" data-index="${idx}">
                <span class="item-index-badge">${idx + 1}</span>
                <input
                  type="text"
                  class="item-val-input"
                  data-index="${idx}"
                  value="${String(val).replace(/"/g, '&quot;')}"
                  placeholder="Giá trị phần tử ${idx + 1}"
                />
                <button type="button" class="btn-remove-item" data-index="${idx}" title="Xóa phần tử này">&times;</button>
              </div>
            `).join('')}
          </div>
        `}
      </div>

      <div class="editor-bottom-bar">
        <button type="button" class="btn-add-item" id="btn-add-item">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          <span>Thêm phần tử</span>
        </button>
      </div>
    `;
  }

  bindEditorEvents() {
    // Tab switching
    const tabItems = this.bodyEl.querySelectorAll('.list-tab-item');
    tabItems.forEach(tab => {
      tab.addEventListener('click', () => {
        const name = tab.getAttribute('data-list-name');
        if (name && name !== this.activeListId) {
          this.syncCurrentInputs();
          this.activeListId = name;
          tabItems.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          const panel = document.getElementById('list-editor-panel');
          if (panel) {
            panel.innerHTML = this.renderActiveListEditor();
            this.bindEditorEvents();
          }
        }
      });
    });

    const name = this.activeListId;
    if (!name) return;

    // Item input changes
    const inputs = this.bodyEl.querySelectorAll('.item-val-input');
    inputs.forEach(inp => {
      inp.addEventListener('input', (e) => {
        const idx = parseInt(e.target.getAttribute('data-index'), 10);
        if (!isNaN(idx) && this.listData[name]) {
          this.listData[name][idx] = e.target.value;
        }
      });
    });

    // Remove item
    const removeBtns = this.bodyEl.querySelectorAll('.btn-remove-item');
    removeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-index'), 10);
        if (!isNaN(idx) && this.listData[name]) {
          this.syncCurrentInputs();
          this.listData[name].splice(idx, 1);
          this.updatePanelAndTabPill(name);
        }
      });
    });

    // Add item
    const addBtn = document.getElementById('btn-add-item');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        this.syncCurrentInputs();
        if (!this.listData[name]) this.listData[name] = [];
        this.listData[name].push('0');
        this.updatePanelAndTabPill(name);

        // Focus newly added input
        setTimeout(() => {
          const newInputs = this.bodyEl.querySelectorAll('.item-val-input');
          if (newInputs.length > 0) {
            const last = newInputs[newInputs.length - 1];
            last.focus();
            last.select();
          }
        }, 50);
      });
    }

    // Clear all items
    const clearBtn = document.getElementById('btn-clear-list-items');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (confirm(`Bạn có chắc muốn xóa tất cả phần tử của danh sách "${name}"?`)) {
          this.listData[name] = [];
          this.updatePanelAndTabPill(name);
        }
      });
    }

    // Quick CSV Bulk edit
    const bulkBtn = document.getElementById('btn-quick-bulk-edit');
    const bulkBox = document.getElementById('bulk-edit-box');
    const bulkCsvInput = document.getElementById('bulk-csv-input');
    const applyBulkBtn = document.getElementById('btn-apply-bulk');
    const cancelBulkBtn = document.getElementById('btn-cancel-bulk');

    if (bulkBtn && bulkBox) {
      bulkBtn.addEventListener('click', () => {
        this.syncCurrentInputs();
        const currentVals = this.listData[name] || [];
        bulkCsvInput.value = currentVals.join(', ');
        bulkBox.style.display = 'block';
        bulkCsvInput.focus();
      });

      cancelBulkBtn.addEventListener('click', () => {
        bulkBox.style.display = 'none';
      });

      applyBulkBtn.addEventListener('click', () => {
        const rawText = bulkCsvInput.value || '';
        const parsed = rawText.split(',').map(s => s.trim()).filter(s => s.length > 0);
        this.listData[name] = parsed;
        bulkBox.style.display = 'none';
        this.updatePanelAndTabPill(name);
      });
    }
  }

  syncCurrentInputs() {
    const name = this.activeListId;
    if (!name || !this.listData[name]) return;
    const inputs = this.bodyEl.querySelectorAll('.item-val-input');
    inputs.forEach(inp => {
      const idx = parseInt(inp.getAttribute('data-index'), 10);
      if (!isNaN(idx)) {
        this.listData[name][idx] = inp.value;
      }
    });
  }

  updatePanelAndTabPill(name) {
    const pill = document.getElementById(`pill-${name}`);
    if (pill) {
      pill.textContent = (this.listData[name] || []).length;
    }
    const panel = document.getElementById('list-editor-panel');
    if (panel) {
      panel.innerHTML = this.renderActiveListEditor();
      this.bindEditorEvents();
    }
  }

  hide() {
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }
  }

  handleSave() {
    this.syncCurrentInputs();
    const ws = this.getWorkspace ? this.getWorkspace() : null;
    if (ws) {
      ws.listInitialValues = JSON.parse(JSON.stringify(this.listData));
    }

    if (this.onSave) {
      this.onSave(this.listData);
    }

    this.hide();
  }
}
